import { StatusChip } from 'components/ds'
import { resolveLoadStatusStyle } from 'constants/load-status'

/** Email/interaction status pill — reuses the canonical load-status label + palette (the same the
 *  agentic-hub load rows use) so statuses render consistently across the admin. */
export function EmailStatusBadge({ status, reason }: { status: string | null; reason?: string | null }) {
    const { label, bg, text } = resolveLoadStatusStyle(status)
    if (!label) return null
    return <StatusChip label={label} bg={bg} text={text} reason={reason} />
}
